import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import HomeHeader from '../../components/homeHeader/index.vue'
import UserService from '../../services/UserService'
import { showErrorToast, showSuccessToast } from '../../services/UI'
export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  name: 'ActionsTab',
  data () {
    return {
      user: null,
      isActive: true,
      email: '',
      password: '',
      error: '',
      loading: false
    }
  },
  components: {
    HomeHeader
  },
  mounted () {
    // window.analytics.page('SignIn')
    window.analytics.identify('SignIn', {
      path: '/sign_in'
    })
  },
  async created () {
    const user = await UserService.getUser()
    if (user) {
      if (this.$route.query.redirect != null) { this.$router.push(this.$route.query.redirect) } else this.$router.push('/dashboard')
    }
  },
  methods: {
    r () {
      const routeData = this.$router.resolve({ to: '/privacy-policy' })
      window.location.href = routeData
    },
    async login () {
      this.loading = true
      if (
        this.validateEmail() &&
        this.password.length > 0 &&
         (await UserService.login(this.email, this.password))
      ) {
        if (this.$route.query.redirect != null) { this.$router.push(this.$route.query.redirect) } else this.$router.push('/dashboard')
        showSuccessToast(this, 'Login Successfull')
        this.loading = false
      } else {
        this.error = 'Email or password is incorrect'
        showErrorToast(this, this.error)
        this.loading = false
      }
    },
    async loginWithOtp () {
      // this.$router.push({ name: 'loginWithOtp' })
      // this.$router.push('/login_with_otp')
    },
    validateEmail () {
      return /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
    },
    invalidColor () {
      return this.validateEmail() ? {} : { color: 'red' }
    },
    TogglePassword () {
      this.isActive = !this.isActive
      const temp = document.getElementById('inputPassword')
      const x = document.getElementById('hide')
      const y = document.getElementById('show')
      if (temp.type === 'password') {
        temp.type = 'text'
        x.style.display = 'none'
        y.style.display = 'block '
      } else {
        temp.type = 'password'
        x.style.display = 'block'
        y.style.display = 'none '
      }
    }
  },
  computed: {}
}
